import fetch from '@/fetch'
// 获取热搜信息
export const hotSearchGet = (params) => {
  return fetch({
    method: 'post',
    url: '/common/h5/index/search/hotsearch',
    data: params,
    actionTypeCode: '18',
    actionTypeDesc: '热搜信息获取',
  })
}

// 查询分校区空间统计信息
export const spaceSeatGet = (params) => {
  return fetch({
    method: 'post',
    url: '/common/h5/getspaceseat',
    data: params,
    actionTypeCode: '19',
    actionTypeDesc: '各馆信息获取',
  })
}
// 获取公告信息
export const noticeInfoGet = (params) => {
  return fetch({
    method: 'post',
    url: '/common/h5/noticeinfo',
    data: params,
    actionTypeCode: '20',
    actionTypeDesc: '公告信息获取',
  })
}

// 获取轮播图信息
// export const rotationInfoGet = (params) => {
//   return fetch({
//     method: 'post',
//     url: '/common/h5/rotationinfo',
//     data: params,
//     actionTypeCode: '21',
//     actionTypeDesc: '轮播图获取',
//   })
// }

// 获取最新活动
export const newActivityGet = (params) => {
  return fetch({
    method: 'post',
    url: '/common/h5/getactivityinfo',
    data: params,
    actionTypeCode: '22',
    actionTypeDesc: '最新活动获取',
  })
}

// 获取新书推荐信息
export const newBookGet = (params) => {
  return fetch({
    method: 'post',
    url: '/common/h5/index/newbook',
    data: params,
    actionTypeCode: '23',
    actionTypeDesc: '新书推荐获取',
  })
}
